<template>
  <div>
    <v-data-table :headers="headers" :items="flats" :search="search" class="elevation-3">
      <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  clearable
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  class="col-md-6"
                  @input="sessionStorage(search)"
                ></v-text-field>
        </template>
      <template v-slot:item.profile_url="{ item }">
        <v-avatar
          size="40"
          v-if="item && item.profile_url != null"
          class="mb-3 mt-3"
        >
          <v-img
            :src="API_BASE_URL + '/uploads/' + item.profile_url"
            :alt="item.name"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-avatar>
        <v-avatar
          v-else
          color="primary lighten-4 primary--text"
          class="white--text mb-3 mt-3"
          size="40"
        >
          <span class="fontsize-11">{{ item.name.charAt(0) }}</span>
        </v-avatar>
      </template>
      <template v-slot:item.house_number="{ item }">
                <span v-if="item.flat">{{ item.flat.name }}-</span>
                <span>{{ item.house_number }}</span>

      </template>
     
      <template v-slot:item.email="{ item }">
        {{ item.email ? item.email : 'N/A' }}
      </template>

      <!-- <template v-slot:item.mobile_no="{ item }">
        {{ `${item.country_code} ${item.mobile_no}`}}
      </template> -->

      <template v-slot:item.member_type="{ item }">
        {{ memberType(item.member_type) }}
      </template>
      <template v-slot:item.last_active_time="{ item }">
                {{ getFormattedDate(item.last_active_time) }}
              </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              :to="'/superadmin/society/list/' + society_id + '/member/'+item.id"
            >
              <v-icon small> mdi-eye </v-icon>
            </v-btn>
          </template>
          <span>View Details</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  props:{
   'society_id':String 
  },
  data() {
    return {
      search: "",
      flats: [],
      members: [],
      memberTypes: [
        {
          id: '1',
          name: 'Owner',
        },
        {
          id: '2',
          name: 'Tenant',
        }
      ],
      headers: [
        { text: `${this.$t('society.list.members.profile')}`, value: 'profile_url', width: '15%', sortable: false},
        // { text: `${this.$t('society.list.members.flat')}`, value: 'flat_id', width: '10%' },
        { text: `${this.$t('society.list.members.houseNo')}`, value: 'house_number', width: '15%' },
        // { text: `${this.$t('society.list.members.resident')}`, value: 'member_type', width: '15%' },
        {
          text: `${this.$t('society.list.members.name')}`,
          align: 'start',
          value: 'name',
          width: '20%'
        },
        // { text: `${this.$t('society.list.members.mobileNo')}`, value: 'mobile_no', width: '20%' },
        {
          text: `${this.$t("members.headers.LastActiveTime")}`,
          value: "last_active_time",
          sortable: false,
          width: "15%",
        },
        { text: `${this.$t('society.list.members.actions')}`, value: 'actions', width: '10%', sortable: false },
      ],
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getSocietyFlats() {
      let _self = this;
      new Promise((resolve,reject) => {
        _self.$axios
          .get(`society/${this.society_id}/members`)
          .then((response) => {
            let data = response.data;
            if (data.status) {
              resolve();
              _self.flats = data.members;
            } else {
              reject();
              _self.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          });
      })
      .then(() => {
        _self.getSocietyMembers();
      });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    getSocietyMembers() {
      let _self = this;

      _self.$axios
        .get(`superadmin/society/${this.society_id}/members`)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.members = data.members;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    memberType(memberType) {
      let membertpye = this.memberTypes.find(
        (type) => type.id == memberType
      );
      return membertpye ? membertpye.name : "N/A";
    },
    flat(flat_id) {
      let flat = this.flats.find(flat => flat.id == flat_id);
      return flat ? flat.name : "N/A";
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("member_search");
      } else {
        sessionStorage.setItem("member_search", search);
      }
    },
  },
  mounted() {
    this.getSocietyFlats();
     this.search = sessionStorage.getItem("member_search");
  }
};
</script>